<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      :title="dialogTitle"
      :modal-append-to-body="false"
      width="70%"
      style="margin-top: 120px"
    >
      <div class="upload-content">
        <el-steps :active="step" simple>
          <el-step title="上传文件" icon="el-icon-upload"></el-step>
          <el-step title="导入完成" icon="el-icon-success"></el-step>
        </el-steps>
        <template v-if="step === 1">
          <div class="step">
            <div class="step-head">
              一、请按照数据模板的格式准备要导入的数据。
              <el-button type="text" @click="handleDownload">
                点击下载
              </el-button>
            </div>
            <div class="step-content">导入文件请勿超过2MB (约10,000条数据)</div>
          </div>
          <div class="step">
            <div class="step-head">二、请选择需要导入的文件。</div>
            <div class="step-content">
              <el-upload
                :on-change="handleChange"
                :on-remove="handleRemove"
                :auto-upload="false"
                :file-list="fileList"
                action="#"
                accept=".xlsx, .xls"
              >
                <el-button size="small" type="primary"> 选择文件 </el-button>
              </el-upload>
            </div>
          </div>
        </template>
        <template v-if="step === 2">
          <div class="success-container">
            <div class="el-icon-circle-check"></div>
            导入完成
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <template v-if="step === 1">
          <el-button @click="finished">关闭</el-button>
          <el-button
            :disabled="fileList.length === 0"
            type="primary"
            @click="handleImport"
          >
            导入文件
          </el-button>
        </template>
        <template v-if="step === 2">
          <el-button type="primary" @click="finished"> 关闭 </el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/retail";
export default {
  name: "upload",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 是需要哪种类型导入的模板
    // 1：零售负责人；
    // 2：支持部门长；
    // 3：运营提成；
    // 4：后端绩效
    pmManager: {
      type: String,
    },
    taskid: {
      type: String,
    },
    dialogTitle: {
      type: String,
      default:'导入'
    },
    // EBITDA达成率
    editRate: {
      type: [String,Number],
    },

  },
  data() {
    return {
      step: 1,
      dialogVisible: false,
      fileList: [],
      file: null,
    };
  },
  watch: {
    visible(v) {
      this.dialogVisible = v;
    },
  },
  methods: {
    beforeClose(done) {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      done();
    },
    handleChange(file) {
      // 1. 校验文件类型
      const allowedTypes = [
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      ];
      if (!allowedTypes.includes(file.raw.type)) {
        this.$message.error("只能上传Excel文件（.xls 或 .xlsx）");
        this.fileList = []; // 清空非法文件
        return;
      }

      // 2. 校验文件大小（2MB = 2 * 1024 * 1024 Bytes）
      const maxSize = 2 * 1024 * 1024;
      if (file.raw.size > maxSize) {
        this.$message.error("文件大小不能超过2MB");
        this.fileList = []; // 清空超大文件
        return;
      }

      // 3. 通过校验，保留文件
      this.fileList = [file];
    },
    handleRemove() {
      this.fileList = [];
    },

    handleDownload() {
      console.log(222);
      
      api.downTemplate({ type: this.pmManager }).then((res) => {
        if (res.msg == "success") {
        // window.open(res.data);
          const link = document.createElement('a');
          link.href = res.data;
          // link.download = 'template.xlsx'; // 设置下载文件名
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    },
    async handleImport() {
      console.log(this.editRate,'this.editrate');
      
      try {
        // 1. 上传文件
        const formData = new FormData();
        formData.append(
          "b068931cc450442b63f5b3d276ea4297",
          this.fileList[0].raw
        );
        const uploadRes = await api.importExcel(formData);
        console.log(uploadRes, "上传结果");

        // 2. 如果上传成功，导入数据
        if (uploadRes.code === 1) {
          let params = {
            type: this.pmManager,
            taskid: this.taskid,
            file: uploadRes.data?.url,
          };
          if(this.pmManager==2||this.pmManager==4){
            params.ebitda=this.editRate;
          }
          const importRes = await api.importTableData(params);
          this.$emit("success");
          this.step = 2;
          this.$message.success('导入成功');
          this.finished();


        }
      } catch (error) {
        console.error("导入失败:", error);
        // 可以在这里统一处理错误（如提示用户）
        // this.$message.error(error);
      }
    },
    finished() {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);

    },

  },
};
</script>

<style lang="scss" scoped>
.step {
  margin-top: 20px;

  .step-head {
    font-weight: bold;
  }

  .step-radio {
    margin: 20px 0;
  }

  .step-content {
    margin-top: 20px;
  }
}

.success-container {
  line-height: 100px;
  text-align: center;
  font-size: 30px;
  color: #409eff;
}
::v-deep {
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-step__arrow::before {
    height: 13px !important;
    width: 2px !important;
  }
  .el-step__arrow::after {
    height: 13px !important;
    width: 2px !important;
  }
  .el-dialog__body {
    max-height: 60vh;
    overflow: auto;
  }
  .el-table__body {
    width: 100% !important;
  }
  .el-table th.gutter {
    display: none;
    width: 0;
  }
  .el-table colgroup col[name="gutter"] {
    display: none;
    width: 0;
  }
  .el-table--scrollable-y .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 0 !important;
    }
  }
  .dialog-footer {
    button {
      height: 70px;
    }
  }
}
</style>
